(() => {
  const root = document.querySelector('.lp');
  const dataEl = root && root.querySelector('#lp-data');
  if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => root.querySelectorAll(s);

  /* Gallery: scroll-snap track, arrows, thumbnails, counter */
  const track = $('.lp-track');
  const slides = track ? [...track.children] : [];
  const count = $('.lp-count');
  const prev = $('.lp-prev');
  const next = $('.lp-next');
  let current = 0;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mark(i) {
    current = i;
    if (count) count.textContent = `${i + 1} / ${slides.length}`;
    $$('.lp-thumbs button').forEach((b, j) => b.setAttribute('aria-pressed', String(j === i)));
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
  }
  function go(i, smooth = true) {
    if (!track || !slides[i]) return;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    mark(i);
  }
  if (track && slides.length) {
    let t;
    track.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => mark(Math.round(track.scrollLeft / track.clientWidth)), 60);
    }, { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(current + 1, slides.length - 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(current - 1, 0)); }
    });
    prev && prev.addEventListener('click', () => go(Math.max(current - 1, 0)));
    next && next.addEventListener('click', () => go(Math.min(current + 1, slides.length - 1)));
    $$('.lp-thumbs button').forEach((b) => b.addEventListener('click', () => go(+b.dataset.index)));
    mark(0);
  }

  /* Lightbox */
  const dialog = $('.lp-lightbox');
  if (dialog && typeof dialog.showModal === 'function') {
    const big = dialog.querySelector('img');
    slides.forEach((s) => s.addEventListener('click', () => {
      const img = data.images[+s.dataset.index];
      if (!img) return;
      big.src = img.src; big.alt = img.alt;
      dialog.showModal();
    }));
    $('.lp-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
  }

  /* Quantity */
  const qty = $('#lp-quantity');
  const minus = $('.lp-minus');
  const plus = $('.lp-plus');
  function tidy() {
    qty.value = Math.max(1, Math.min(99, parseInt(qty.value, 10) || 1));
    minus.disabled = +qty.value <= 1;
    plus.disabled = +qty.value >= 99;
  }
  if (qty) {
    minus.addEventListener('click', () => { qty.value = +qty.value - 1; tidy(); });
    plus.addEventListener('click', () => { qty.value = +qty.value + 1; tidy(); });
    qty.addEventListener('change', tidy);
    tidy();
  }

  /* Variant selection */
  const form = $('#lp-form');
  const notice = $('.lp-notice');
  const picked = () => form.querySelector('[name=id]:checked') || form.querySelector('[name=id]');
  const variantFor = (id) => data.variants.find((v) => v.id === String(id));
  function apply(v, updateUrl) {
    if (!v) return;
    $$('.lp-option-name').forEach((n) => { n.textContent = v.option; });
    const price = $('.lp-price-now'); if (price) price.textContent = v.price;
    const addPrice = $('.lp-add-price'); if (addPrice) addPrice.textContent = v.price;
    const stickyPrice = $('.lp-sticky-price'); if (stickyPrice) stickyPrice.textContent = v.price;
    $$('.lp-add').forEach((b) => {
      b.disabled = !v.available;
      const label = b.querySelector('.lp-add-label') || b;
      label.textContent = v.available ? 'Add to cart' : 'Sold out';
    });
    if (notice) notice.textContent = '';
    if (v.image) {
      const i = data.images.findIndex((img) => img.id === v.image);
      if (i >= 0) go(i, updateUrl);
    }
    if (updateUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
  }
  $$('.lp-swatches input').forEach((r) => r.addEventListener('change', () => apply(variantFor(r.value), true)));
  apply(variantFor(picked() && picked().value), false);

  /* Submit: sold-out guard and optional add-on */
  const pairCheck = $('.lp-pair-check');
  const pairVariant = $('.lp-pair-variant');
  form.addEventListener('submit', async (e) => {
    if (qty) tidy();
    const v = variantFor(picked() && picked().value);
    if (v && !v.available) {
      e.preventDefault();
      notice.textContent = 'This option is sold out. Please choose another.';
      return;
    }
    if (!pairCheck || !pairCheck.checked || !pairVariant) return;
    e.preventDefault();
    const buttons = $$('.lp-add');
    buttons.forEach((b) => b.setAttribute('aria-busy', 'true'));
    try {
      const res = await fetch(data.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(picked().value), quantity: qty ? +qty.value : 1 },
          { id: Number(pairVariant.value), quantity: 1 }
        ] })
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
      location.href = data.cart;
    } catch (err) {
      notice.textContent = `${err.message}. Please try again, or untick the add-on.`;
      buttons.forEach((b) => b.removeAttribute('aria-busy'));
    }
  });

  /* Sticky bar: appears once the main Add to cart button has scrolled out of view */
  const sticky = $('.lp-sticky');
  const mainAdd = $('.lp-buyrow');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', show);
      sticky.inert = !show;
    }).observe(mainAdd);
    sticky.inert = true;
  }

  /* Demonstration video: no autoplay for reduced-motion users */
  if (reduce) $$('.lp-demo video').forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });
})();
